const USER_ROLE = {
    ADMIN: 'ADMIN',
    GUEST: 'GUEST',
    
};

export default USER_ROLE;
